/*
 * @Author: cn1994
 * @Date: 2023-09-15 17:28:30
 * @LastEditors: cn1994
 * @LastEditTime: 2023-09-15 17:40:10
 * @Description: 用户store
 */
import { defineStore } from 'pinia'
import { useBaseStore } from './base'

export const useUserStore = defineStore('userStore', {

  state: () => {
    return {
      baseStore: useBaseStore()
    }
  },
  getters: {
    role: (state) => {
      return state.baseStore.userInfo.role
    },
    token: (state) => {
      return state.baseStore.userInfo.token
    },
    userId: (state) => {
      return state.baseStore.userInfo.userId
    },
    serverId: (state) => {
      return state.baseStore.userInfo.server_id
    },
    instId: (state) => {
      return state.baseStore.userInfo.inst_id
    },
    userName: (state) => {
      return state.baseStore.userInfo.username
    },
    appVersion: (state) => {
      return state.baseStore.userInfo.appVersion
    },
    adminRole: (state) => {
      return state.baseStore.userInfo.adminRole
    },
    instCode: (state) => {
      return state.baseStore.userInfo.inst_code
    },
    DATA_URL_TPEMS_MENU: (state) => {
      return state.baseStore.userInfo.DATA_URL_TPEMS_MENU
    },
    isPersionLimit: (state) => {
      return state.baseStore.userInfo.isPersionLimit
    },
    mainCampusId: (state) => {
      return state.baseStore.userInfo.mainCampusId
    },
    mainCourseId: (state) => {
      return state.baseStore.userInfo.mainCourseId
    },
    mainInstId: (state) => {
      return state.baseStore.userInfo.mainInstId
    },
    startPayDate: (state) => {
      return state.baseStore.userInfo.startPayDate
    },
    domain: (state) => {
      return state.baseStore.userInfo.domain
    },
    nickName: (state) => {
      return state.baseStore.userInfo.nickname
    },
    newUgcUrl: (state) => {
      return state.baseStore.userInfo.new_ugc_url
    },
    studentIsShow: (state) => {
      return state.baseStore.userInfo.studentIsShow
    },
    tokenType: (state) => {
      return state.baseStore.userInfo.tokenType
    },
    evalutionVersion: (state) => {
      return state.baseStore.userInfo.evalutionVersion
    },
    instTitle: (state) => {
      return state.baseStore.userInfo.instTitle
    },
    showPlusUI: (state) => {
      return state.baseStore.userInfo.showPlusUI
    },
    openUserId: (state) => {
      return state.baseStore.userInfo.openUserId
    },
    siteAdminUrl: (state) => {
      return state.baseStore.userInfo.site_admin_url
    },
    ugcEditUrl: (state) => {
      return state.baseStore.userInfo.ugc_edit_url
    },
    courseName: (state) => {
      return state.baseStore.userInfo.courseName
    },
    mainCourse: (state) => {
      return state.baseStore.userInfo.mainCourse
    },
    mainCampusCode: (state) => {
      return state.baseStore.userInfo.mainCampusCode
    },
  },
  actions: {

  },
  persist:
  {
    storage: sessionStorage,
    enabled: true
  }
})